<template>
  <div id="invoiceRouting" class="flex align-center justify-center">
    <button @click="pushTo('Form', Object.assign(route.query, {form:'type1'}))" class="pointer rounded font-gothic">この内容で仮オーダーする</button>
    <button @click="pushTo('Form', Object.assign(route.query, {form:'type3'}))" class="pointer rounded font-gothic">迷っているので相談したい</button>
    <button @click="toggleAlartDialog(true)" class="pointer rounded last font-gothic">最初からやり直す</button>
  </div>
</template>

<script>
import {useRoute} from "vue-router";
import useRoutePush from "@/modules/moduleA/helpers/useRoutePush";
import {useStore} from "vuex";
export default {
  name: "InvoiceRouting",
  setup(){
    const route = useRoute()
    const {pushTo} = useRoutePush()
    const store = useStore()

    const toggleAlartDialog = (param) => {
      store.commit("setAlartDialog", param);
    }

    return {route, pushTo, toggleAlartDialog}
  }
}
</script>

<style scoped>
#invoiceRouting {
  width: 100%;
  height: 100%;
  background-color: #1e272e;
}
#invoiceRouting > button {
  font-size: .8rem;
  color: #171717;
  height: 45px;
  padding: 4px 20px 2px 20px;
  background-color: rgb(173, 219, 214);
  line-height: 1.3;
}
#invoiceRouting > button:nth-child(2) {
  margin: 0 20px;
}
#invoiceRouting > button.last {
  background-color: white;
}
</style>
